import { createTheme } from "@material-ui/core/styles";
import aASmartSansArray from './AASmartSans';

const main = createTheme ({
  palette: {
    primary: {
      light: "#9aa2d5",
      main: "#465eb6",
      dark: "#031795",
      contrastText: "#FFFFFF",
    },
    secondary: {
      light: "#abcbfa",
      main: "#6fa5f9",
      dark: "#347ff6",
    },
    success:{
      light: "#C3E0C5",
      main: "#97CA83",
      dark: "#64B246",
    },
    warning:{
      light: "#FFD2A7",
      main: "#FFB066",
      dark: "#FE8C00",
    },
    error:{
      main: "#FE0000",
    },
    grey: {
      main: "#666666",
      light: "#a7a7a7"
    },
    background: {
      default: "#FFFFFF"
    }
  },
  typography: {
    fontFamily: [
      'AASmartSans',
      'Arial',
    ].join(','),
    h4:{
      fontWeight: 100,
      fontSize: "2.125rem",
      background: "linear-gradient(90deg, #FE0000 0%, #031795 30%, #347ff6 100%)", 
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    h5: {
      fontWeight: 100,
      fontSize: "1.5rem",
      background: "linear-gradient(90deg, #FE0000 0%, #031795 30%, #347ff6 100%)", 
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
    },
    subtitle1: {
      fontWeight: 700,
      fontSize: "1rem",
      color: "#666666"
    },
    subtitle2:{
      fontWeight: 700,
      fontSize: "1.25rem",
      color: "#031795",
    },
    body1: {
      fontWeight: 400,
      fontSize: "1rem",      
    },
  },
  overrides: {
    MuiCssBaseline: {
      '@global': {
        '@font-face': [...aASmartSansArray],
      },
    },
  },
});

const menu = createTheme ({
  palette: {
    primary: {
      light: "#FFFFFF",
      main: "#FFFFFF",
      dark: "#002776",
      contrastText: "#002776",
    },
    secondary: {
      light: "#FFFFFF",
      main: "#0075B0",
      dark: "#002776",
      contrastText: "#0075B0",
    },
  }
});

export default {
  main,
  menu
}
